import PropTypes from 'prop-types';
import React, { useEffect, useState, useRef } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Button, Divider, Col, Form, Row, Typography } from 'antd';
import {
  getCreator,
  updateCreatorInfo
} from '../../services/creatorServices';
import BasicInfoEdit from './BasicInfo/BasicInfoEdit';
import Avatar from 'antd/lib/avatar/avatar';
import { DEFAULT_SENDER_EMAIL } from './BasicInfo/utilities';

const { Title, Text } = Typography;

const CreatorPage = (props) => {
  const [creatorData, setCreatorData] = useState({});
  const [isBasicEditOpen, setIsBasicEditOpen] = useState(false);
  const [values, setValues] = useState(null);
  const [status, setStatus] = useState({
    type: 'IDLE',
    message: 'On Idle Mode!'
  });
  const formatCreatorValues = (values) => {
    const updateToObject = values.updateToNames.map((name, index) => {
      return { name, email: values.updateToMails[index] };
    });
    values.updateTo = updateToObject;
  };

  const formatUpdateValues = (values) => {
    let updateToNames = [];
    let updateToMails = [];
    values.updateTo.forEach((item) => {
      updateToNames.push(item.name);
      updateToMails.push(item.email);
    });
    let creatorValue = {
      firstName: values.firstName,
      lastName: values.lastName,
      university: values.university,
      email: values.email,
      senderEmail: values.senderEmail
        ? values.senderEmail
        : DEFAULT_SENDER_EMAIL,
      updateToNames,
      updateToMails,
      academyName: values.academyName,
      fbAcademyLink: values.fbAcademyLink,
      bannerImgData: values.bannerImgData,
      thumbnailImgData: values.thumbnailImgData
    };

    return creatorValue;
  };

  const onSubmit = async (values) => {
    const updateValues = formatUpdateValues(values);
    await updateCreatorInfo(props.match.params.university, updateValues)
      .then((response) => {
        console.log('Successfully Updated! ', response);
        setStatus({
          type: 'SUCCESS',
          message: 'Data updated successfully!'
        });
      })
      .catch((error) => {
        alert('Posting data from the backend failed!');
        if (error?.response?.data?.message)
          setStatus({
            type: 'ERROR',
            message: error.response.data.message
          });
        else
          setStatus({ type: 'ERROR', message: 'Something went wrong!' });
      });
  };
  const getData = async () => {
    await getCreator({ university: props.match.params.university })
      .then((response) => {
        if (response.data.length !== 0) {
          const creator = response.data.creator;
          setCreatorData(creator);
          formatCreatorValues(creator);
          setValues(creator);
        } else {
          throw Error('This course offer does not exist!');
        }
      })
      .catch((err) => {
        console.log('Error getting data from the admin backend:', err);
        alert('Getting data from the backend failed!');
        setStatus({ type: 'ERROR', message: 'Something went wrong!' });
      });
  };

  function toggleBasicEdit() {
    setIsBasicEditOpen((prev) => !prev);
  }
  useEffect(() => {
    getData();
  }, [props.match.params.university]);

  return (
    <div>
      <Row justify="space-between">
        <h2>Basic Creator Info</h2>
        <Button onClick={toggleBasicEdit}>Edit</Button>
      </Row>
      <Row justify="space-between">
        <Col span={16}>
          <Row justify="space-between" gutter={[16, 16]}>
            <Col span={8}>First Name:</Col>
            <Col span={16}>
              <Text strong>{creatorData.firstName}</Text>
            </Col>
          </Row>
          <Row justify="space-between" gutter={[16, 16]}>
            <Col span={8}>Last Name:</Col>
            <Col span={16}>
              <Text strong>{creatorData.lastName}</Text>
            </Col>
          </Row>
          <Row justify="space-between" gutter={[16, 16]}>
            <Col span={8}>University:</Col>
            <Col span={16}>
              <Text strong>{creatorData.university}</Text>
            </Col>
          </Row>
          <Row justify="space-between" gutter={[16, 16]}>
            <Col span={8}>Academy Name:</Col>
            <Col span={16}>
              <Text strong>{creatorData.academyName}</Text>
            </Col>
          </Row>
          <Row justify="space-between" gutter={[16, 16]}>
            <Col span={8}>Facebook Academy Link:</Col>
            <Col span={16}>
              <Link strong>{creatorData.fbAcademyLink}</Link>
            </Col>
          </Row>
          <Col span={8}>
            {creatorData.thumbnailImgData?.desktopImgData?.src ? (
              <Avatar
                shape="square"
                alt="profile"
                src={creatorData.bannerImgData?.desktopImgData?.src}
                size={140}
              />
            ) : (
              <Avatar
                shape="square"
                className="avatar-fallback"
                alt="profile"
                size={140}>
                {creatorData.firstName}
              </Avatar>
            )}
          </Col>
        </Col>
      </Row>

      {values && (
        <>
          <BasicInfoEdit
            type={'UPDATE'}
            toggle={toggleBasicEdit}
            initialValues={values}
            isOpen={isBasicEditOpen}
            status={status}
            onSubmit={onSubmit}
          />
        </>
      )}
    </div>
  );
};

export default withRouter(CreatorPage);
